import Image from "next/future/image";
import React from "react";

export default function WhatWeBelieve() {
   return (
      <section
         id="what-we-believe"
         className="min-h-screen md:h-screen text-black"
      >
         <div className="flex flex-col-reverse md:flex-row h-3/5">
            <div className="md:w-1/2 p-8 md:pt-24">
               <h1 className="text-4xl md:text-5xl underline underline-offset-8 pb-8 font-semibold">
                  What we believe
               </h1>
               <h2 className="text-3xl">
                  We believe creating trust is the way to create long lasting
                  impact.
               </h2>
            </div>
            <div
               className="md:w-1/2 bg-cover h-auto w-full"
               style={{
                  backgroundImage: `url('/discover/what-we-believe.webp')`,
               }}
            >
               <Image
                  src="/discover/what-we-believe.webp"
                  alt="what we believe"
                  className="w-full h-full md:hidden"
                  width="500" height="500"
                  priority={true}
               />
            </div>
         </div>

         <div className="h-2/5 p-8 bg-body-secondary text-white">
            <p className="text-xl whitespace-pre-line">
               {`Our commitment to ethics, integrity, reliability, and strong corporate governance are key drivers of our business strategy and enable us to enable and secure our team, clients, and brand. It is the foundation on which we build trust.

                Our clear corporate governance structure and Ethics & Compliance framework guides our strategic business decisions and actions as we strive to foster a culture of integrity, transparency, inclusivity and respect for all people.
                `}
            </p>
         </div>
      </section>
   );
}
